import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { renderMarkdown } from '~/functions/markdown';
export default /*#__PURE__*/_defineComponent({
  __name: 'IntroNotes',
  setup: function setup(__props) {
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var introNotes = computed(function () {
      return $i18n.t('impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.notes.contents');
    });
    return {
      __sfc: true,
      $i18n: $i18n,
      introNotes: introNotes,
      renderMarkdown: renderMarkdown
    };
  }
});